import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { PlainLink, Stack, Text, TextLabel, Icon } from '@customerio/pluma-components/react';
import type { IconName } from '@customerio/pluma-icons';
import { appendMasqParam } from '@/utils/masq';
import * as styles from '../index.css';

interface MasqLinkProps extends Omit<ComponentPropsWithoutRef<'a'>, 'href' | 'className'> {
  route: string;
  label: string;
  value: string;
  icon?: IconName;
}

export const MasqLink = forwardRef<HTMLAnchorElement, MasqLinkProps>(function MasqLink(
  { route, label, value, icon, ...rest },
  ref,
) {
  return (
    <PlainLink ref={ref} href={appendMasqParam(route)} className={styles.masqueradeBannerItemLink} {...rest}>
      <Stack>
        <TextLabel as="div" variant="secondary">
          {label}
          {icon != null ? (
            <>
              {' '}
              <Icon name={icon} size="xs" />
            </>
          ) : null}
        </TextLabel>
        <Text size="s" weight="semibold">
          {value}
        </Text>
      </Stack>
    </PlainLink>
  );
});
